// Registration/risk device signals sent with every API request.
// Best-effort by spec: iOS Safari/WebView exposes neither model nor
// navigator.connection, so callers must tolerate 'unknown' / ''.
const DEVICE_UUID_KEY = 'device_uuid';

let cachedUUID = '';
let cachedModel = '';

export function getDeviceUUID(): string {
  if (cachedUUID) return cachedUUID;
  try {
    let id = localStorage.getItem(DEVICE_UUID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(DEVICE_UUID_KEY, id);
    }
    cachedUUID = id;
    return id;
  } catch {
    return '';
  }
}

type NetworkInformationLike = { type?: string; effectiveType?: string };

export function getNetworkType(): string {
  if (typeof navigator === 'undefined') return 'unknown';
  const conn = (navigator as { connection?: NetworkInformationLike }).connection;
  if (!conn) return 'unknown';
  const { type, effectiveType } = conn;
  if (type && effectiveType) return `${type}/${effectiveType}`;
  return effectiveType || type || 'unknown';
}

export function getCachedDeviceModel(): string {
  return cachedModel;
}

/** Resolve the Client Hints model once at app startup (Chromium/Android
 *  only; resolves to '' elsewhere). Fire-and-forget from main.tsx. */
export async function primeDeviceModel(): Promise<void> {
  try {
    const uad = (navigator as { userAgentData?: { getHighEntropyValues?: (h: string[]) => Promise<{ model?: string }> } })
      .userAgentData;
    if (uad?.getHighEntropyValues) {
      const { model } = await uad.getHighEntropyValues(['model']);
      cachedModel = (model ?? '').trim();
    }
  } catch {
    // unsupported — leave empty
  }
}

export function __resetDeviceInfoForTests(): void {
  cachedUUID = '';
  cachedModel = '';
}
